export default __webpack_public_path__ + "static/media/T400_CoC.07b85154.pdf";